import { IconArrowRight } from '@consta/icons/IconArrowRight'
import { Text } from '@consta/uikit/Text'
import type { Nullable } from 'common/types'
import type { FC } from 'react'

import css from './WellsTable.css'

type VspNameProps = {
  vspName: Nullable<string>
  isVisible: boolean
  isArrow: boolean
}

export const VspName: FC<VspNameProps> = ({ vspName, isArrow, isVisible }) => (
  <span className={css.vspCell}>
    <Text className={css.vspName} size="s" view="ghost" truncate={true}>
      {vspName}
    </Text>
    {!!isArrow && !!isVisible && <IconArrowRight size="xs" view="secondary" />}
  </span>
)
